export default __webpack_public_path__ + "static/media/rapport.264670d9.jpeg";